import { Component } from '@angular/core';
import { Location } from '@angular/common';

@Component({
    selector: 'app-back-button',
    templateUrl: './back-button.component.html',
    standalone: false
})
export class BackButtonComponent {
  constructor(private location: Location) {}

  public goBack(): void {
    this.location.back();
  }
}
